import { render, staticRenderFns } from "./WarningBannerItem.vue?vue&type=template&id=3c74a186"
import script from "./WarningBannerItem.vue?vue&type=script&lang=js"
export * from "./WarningBannerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports